<template >
 
  <div>
   
      <!-- PC -->
        <v-layout row wrap justify-center>
    
        <v-flex xs12 sm6 md6 lg6>
          <div align="center">
            <v-img  :src="imgproducto" alt="kit de valores" width="100%"></v-img>
            <!--<img alt="Cambiar imagen" width="70%" onmouseout="this.src='KitLalabum1k.png';" onmouseover="this.src='KitLalabum2k.png';" src="KitLalabum1k.png" />-->
           </div>   
        </v-flex>
        <v-flex xs10 sm6 md6 lg6>
          <p   :class="`producto ${id}`">{{title}}</p>
              <p  class="description">{{txt1}}</p>
              <p  class="description">{{txt4}}</p>
              <ul class="description" v-for="contenido in contenidos" :key="contenido.title" >
                <li>{{contenido.title}}</li>
              </ul>
              <br>
               <p  class="description">{{txt2}}</p>
               <p  class="description">{{txt3}}</p>

               <v-layout>
                  <p class="producto" style="color:#EF5A24">Cómpralo en:</p>  
               </v-layout>
               <v-layout>
                  <div class="columns">
                <div class="column is-6">
                    <table class="table is-fullwidth is-striped" style="margin-top:5%" v-for="venta in ventas" :key="venta.comercio">
                        <tbody>
                            <tr>
                                <td class="comercio" width="200px">{{venta.comercio}}</td>
                                <td>
                                    <a :href="venta.url" target="_blank" style="text-decoration:none">
                                        <v-btn color="info" class="button" small round>Comprar</v-btn>  
                                    </a>
                                </td>
                            </tr>
                            
                        </tbody>
                    </table>

                </div>
          </div>
               </v-layout>
        </v-flex>
        </v-layout>
    


  </div>
</template>

<script>
//import VueGallerySlideshow from 'vue-gallery-slideshow'
//import VueGallery from 'vue-gallery';

  export default {

  props:['producto','title','imgproducto','txt1','contenidos','txt2','txt3','ventas','id','txt4'],
    
  components:{
  },  
    data(){
    let language=localStorage.getItem('language');
    //echo (language);
    
    

      if (language=='es-XL' || language=='es') 
      {
        return{      
        

        }
      } else {
        return{      
         productos:[
            {id:"kit1",title:"Hábitos de higiene",image:"KitLalabum1k.png",description:"Diseñado para reforzar las buenas conductas y actitudes hacia el cuidado personal. Es ideal para niños entre 2 y 4 años. Incluye acceso a la app Mundo Lalabum",linkml:"https://cutt.ly/lgYSAmK",linkpp:"https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=VEUNJ9AZHHQQS",},
            {id:"kit2",title:"Deberes en casa",image:"KitLalabum2k.png",description:"Diseñado para reforzar las buenas conductas y actitudes hacia los deberes en casa. Es ideal para niños entre 3 y 5 años. Incluye acceso a la app Mundo Lalabum",linkml:"https://cutt.ly/fgYSSUC",linkpp:"https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=YJF59EWX4WE2L"},
            {id:"kit3",title:"Alimentación sana",image:"KitLalabum3k.png",description:"Diseñado para reforzar las buenas conductas y actitudes hacia una alimentación sana. Es ideal para niños entre 5 y 7 años. Incluye acceso a la app Mundo Lalabum",linkml:"https://cutt.ly/egYSDR8",linkpp:"https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=U9ZCAF7GF77DE"},
            {id:"kit1",title:"Valores en acción 1",image:"LibroLalabum1k.png",description:"Desarrollo de las rutinas, hábitos de higiene, autoconcepto y convivencia sana para niños de 2 a 4 años. Incluye acceso a plataforma para descargar material y a la app Mundo Lalabum",linkml:"https://cutt.ly/4gYJovD",linkpp:"https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=VP8QXMD8ASR6A",},
            {id:"kit2",title:"Valores en acción 2",image:"LibroLalabum2k.png",description:"Desarrollo de autonomía, expresión de las emociones, respeto a la autoridad, modales y disciplina para niños de 4 a 5 años. Incluye acceso a plataforma para descargar material y a la app Mundo Lalabum",linkml:"https://cutt.ly/FgYJpas",linkpp:"https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=555ZVFNSSURDA"},
            {id:"kit3",title:"Valores en acción 3",image:"LibroLalabum3k.png",description:"Desarrollo de habilidades para comunicarse y convivir sanamente, el cuidado del medio ambiente para niños de 5 a 6 años. Incluye acceso a plataforma para descargar material y a la app Mundo Lalabum",linkml:"https://cutt.ly/1gYJpAg",linkpp:"https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=K8AXXKNAG3NMJ "},
          ],

        }
      }      
    },
    methods: {
       onClick(i) {
      this.index = i;
    },
    getColor (calories) {
        if (calories > 400) return 'red'
        else if (calories > 200) return 'orange'
        else return 'green'
      },
    
    }
    
  }

</script>
<style scoped>
/* Fuentes */
@import url('https://fonts.googleapis.com/css?family=Fredoka+One|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i');


/* Description Container */

.container {
  position: relative;
  width: 100%;
}


.container:hover .overlay {
  opacity: .9;
}

.text {
  font-family: poppins;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}

@media (min-width: 1200px){
    .text{ 
        font-size:1.3vw;   
    }
    .producto{
         font-size:2vw;
    }

    .description{
      font-size: 1.4vw;
    }

    .comercio{
      font-size:1.5vw
    }
}

@media (min-width: 300px) and (max-width: 750px){
    .text{
        font-size: 4.3vw;
    }
    .producto{
        font-size: 8vw;
    }

    .description{
      font-size: 5vw;
    }

    .comercio{
      font-size:5.5vw
    }
}

.producto{
  text-align: left;
  font-weight: 500;
  font-family: Fredoka one;
  
}


.description.kit1,.producto.kit1{
    color:#792364;
}
.description.kit2,.producto.kit2{
    color:#50b05e;
}

.description.kit3,.producto.kit3{
    color:#338ec9;
}

.description{
  text-align: left;
  font-weight: 450;
  font-family: Poppins;
  color:#333333;
  
}

.button{
  text-transform:capitalize; 
  font-family:Fredoka one; 
}

.comercio{
  font-family:poppins;
}

</style>
